import { VectorRender } from './Render';
const DEFAULT_CHUNK_SIZE = 50;
export class PathRender extends VectorRender {
    constructor({ path, renders, chunkSize = DEFAULT_CHUNK_SIZE }) {
        super();
        this.cachedPaths = {};
        this.renders = renders;
        this.chunkSize = chunkSize;
        if (path) {
            this.path = path;
        }
        else {
            this.initializePath();
        }
    }
    initializePath() {
        this.path = new Path2D();
        this.addRendersToPath();
    }
    addRendersToPath() {
        this.validateCache();
        for (let i = 0; i <= Math.round(this.renders.length / this.chunkSize); i++) {
            if (this.cachedPaths[i] && !this.cachedPaths[i].updateNeeded) {
                this.path.addPath(this.cachedPaths[i].path);
                this.cachedPaths[i] = Object.assign(Object.assign({}, this.cachedPaths[i]), { hadUpdate: false });
            }
            else {
                let path = new Path2D();
                for (let j = 0; j < this.chunkSize; j++) {
                    const render = this.renders[i * this.chunkSize + j];
                    if (!render) {
                        break;
                    }
                    this.addObject(path, render);
                }
                this.cachedPaths[i] = {
                    path,
                    updateNeeded: false,
                    hadUpdate: true,
                };
                this.path.addPath(path);
            }
        }
        this.previousRenders = this.renders;
    }
    validateCache() {
        if (!this.previousRenders) {
            return;
        }
        const isAdd = this.previousRenders.length < this.renders.length;
        const isDelete = this.previousRenders.length > this.renders.length;
        if (isDelete) {
            this.cachedPaths = {};
            return;
        }
        for (let i = 0; i <= Math.round(this.renders.length / this.chunkSize); i++) {
            for (let j = 0; j < this.chunkSize; j++) {
                const render = this.renders[i * this.chunkSize + j];
                if (!render) {
                    break;
                }
                if (render && render.updateNeeded) {
                    this.updateNeeded = true;
                    this.cachedPaths[i] = Object.assign(Object.assign({}, this.cachedPaths[i]), { updateNeeded: true });
                    if (isAdd && this.cachedPaths[i + 1]) {
                        for (let j = i + 1; j <= Math.round(this.renders.length / this.chunkSize); j++) {
                            if (this.cachedPaths[j]) {
                                this.cachedPaths[j] = Object.assign(Object.assign({}, this.cachedPaths[j]), { updateNeeded: true });
                            }
                        }
                        return;
                    }
                    break;
                }
            }
        }
    }
    updateRenders(renders) {
        this.path = new Path2D();
        this.renders = renders;
        this.addRendersToPath();
    }
    contains(position) {
        return this.renders.findIndex((render) => render.contains(position)) !== -1;
    }
}
